import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import { dismissCompletion } from '../../features/completion/completionSlice';
export const formatDuration = (ms) => {
    const totalMinutes = Math.round(ms / 60000);
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = totalMinutes % 60;
    if (days > 0) {
        return `${days}d ${hours}h ${minutes}m`;
    }
    if (hours > 0) {
        return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
};
const describe = (record) => record == null
    ? 'Never'
    : `${new Date(record.timestamp).toLocaleString()} (took ${formatDuration(record.durationMs)})`;
export const CompletionDialog = () => {
    const dispatch = useDispatch();
    const pending = useSelector((state) => state.completion.pending);
    if (pending == null) {
        return null;
    }
    const headline = pending.postponed === 0
        ? `Board complete! Took ${formatDuration(pending.durationMs)}.`
        : `Board cleared: ${pending.postponed} postponed. Took ${formatDuration(pending.durationMs)}.`;
    return (React.createElement(Dialog, { open: true, onClose: () => dispatch(dismissCompletion()) },
        React.createElement(DialogTitle, null, headline),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null,
                "+",
                pending.awarded,
                " points"),
            React.createElement(DialogContentText, null,
                "Last time all tasks were completed: ",
                describe(pending.previousAllComplete)),
            React.createElement(DialogContentText, null,
                "Last time all tasks were completed or postponed: ",
                describe(pending.previousCompletePostponed))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => dispatch(dismissCompletion()) }, "Close"))));
};
